import { CoreIcon } from '../core-icon';
import upDownSVG from '../../assets/icons/up-down.svg';
import type { IconProps } from '../core-icon';

export const UpDownIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={upDownSVG} {...props} />;
};
